export enum ShareType {
  WhatsApp = 'WhatsApp',
  Email = 'Email',
  ShareLink = 'ShareLink'
}

export enum ShareComponent {
  LocationOverlay = 'LocationOverlay',
  HotelDetails = 'HotelDetails',
  HotelDetailsTopBar = 'HotelDetailsTopBar',
  FullScreenImageGallery = 'FullScreenImageGallery',
  VerticalGalleryOverlay = 'VerticalGalleryOverlay'
}
